module.exports = __webpack_public_path__ + "static/img/1078.b866b75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1078.jpg
// module id = 260
// module chunks = 0